/**
 * RequiredFieldsBlockModal — o servidor recusou mover o lead (409
 * required_fields): faltam campos obrigatórios da etapa de destino e/ou o
 * nome do lead é só o telefone. Aqui a pessoa preenche e tenta de novo, sem
 * sair do funil. Reunião myCar 03/09 ("o lead não mexe se o campo é
 * obrigatório"). Compartilhado: Kanban e seletor de etiqueta.
 */
import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import CustomFieldsPanel from './CustomFieldsPanel';
import whatsappService from '../../services/wa-personal/whatsappService';

const RequiredFieldsBlockModal = ({ colors, phone, detail, onRetry, onClose }) => {
  const [name, setName] = useState(detail?.name && !detail?.name_missing ? detail.name : '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const missing = detail?.missing || [];
  const nameMissing = Boolean(detail?.name_missing);

  const handleRetry = async () => {
    setSaving(true);
    setError('');
    try {
      if (nameMissing) {
        const trimmed = (name || '').trim();
        if (!trimmed || !/[a-zA-ZÀ-ÿ]{2,}/.test(trimmed)) {
          setError('Informe o nome do lead (não pode ser só o telefone).');
          setSaving(false);
          return;
        }
        await whatsappService.updateContactPushName(phone, trimmed);
      }
      await onRetry?.();
    } catch (e) {
      const d = e?.response?.data?.detail;
      if (d && d.code === 'required_fields') {
        setError('Ainda faltam: ' + [...(d.missing || []).map((m) => m.name), ...(d.name_missing ? ['nome do lead'] : [])].join(', '));
      } else {
        setError('Não foi possível salvar. Tente novamente.');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 520, maxHeight: '90vh', overflowY: 'auto', backgroundColor: colors.bgPrimary, borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: `1px solid ${colors.borderColor}` }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
            <AlertTriangle size={16} color="#f59e0b" />
            Preencha antes de mover
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: colors.textSecondary, padding: 6 }}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: '14px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <p style={{ margin: 0, fontSize: 12.5, color: colors.textSecondary, lineHeight: 1.5 }}>
            A etapa de destino exige {missing.length ? `os campos ${missing.map((m) => m.name).join(', ')}` : ''}
            {missing.length && nameMissing ? ' e ' : ''}
            {nameMissing ? 'o nome do lead (o cadastro está só com o telefone)' : ''}.
          </p>
          {nameMissing && (
            <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, color: colors.textPrimary }}>
              Nome do lead
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Como o cliente se chama"
                maxLength={120}
                style={{ padding: '9px 11px', borderRadius: 8, border: `1px solid ${colors.borderColor}`, backgroundColor: colors.bgSecondary, color: colors.textPrimary, fontSize: 13 }}
              />
            </label>
          )}
          {missing.length > 0 && (
            <CustomFieldsPanel colors={colors} phone={phone} compact hideHeader />
          )}
          {error && <div style={{ fontSize: 12, color: '#ef4444' }}>{error}</div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button type="button" onClick={onClose} style={{ padding: '8px 14px', borderRadius: 8, border: `1px solid ${colors.borderColor}`, background: 'transparent', color: colors.textSecondary, fontSize: 13, cursor: 'pointer' }}>
              Cancelar
            </button>
            <button type="button" onClick={handleRetry} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', backgroundColor: colors.accentPrimary, color: '#fff', fontSize: 13, fontWeight: 600, cursor: saving ? 'wait' : 'pointer', opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Salvando...' : 'Salvar e mover'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequiredFieldsBlockModal;
